import React, { useEffect, useCallback } from 'react';

import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { getCompaniesOfMeBasic } from 'redux/companiesOfMeBasic/actions';
import CompanyFilter from './CompanyFilter';
import CompanyListSelect from './CompanyListSelect';

const CompanyForm = () => {
  const dispatch = useDispatch();

  const retrieveList = useCallback(
    ({ filter = {}, isRefresh, keepFilter }) => {
      dispatch(
        getCompaniesOfMeBasic({
          data: {
            orderBy: 'name',
            ...filter,
            filter: filter.filter,
          },
          options: {
            keepFilter,
            isRefresh,
          },
        }),
      );
    },
    [], // eslint-disable-line
  );

  useEffect(() => {
    retrieveList({
      filter: {
        limit: 10,
        offset: 0,
      },
      isRefresh: true,
    });
  }, []); // eslint-disable-line

  return (
    <div>
      <div className="title-session">{i18next.t('users.selectCompanies')}</div>
      <CompanyFilter retrieveList={retrieveList} />
      <CompanyListSelect retrieveList={retrieveList} />
    </div>
  );
};

export default CompanyForm;
